export const SAVED_PHRASE_CONTEXT_EDITOR_TITLE = 'Edit saved phrase context';
export const SAVED_PHRASE_CONTEXT_EDITOR_BUTTON = 'Save phrase with new context';

export const PHRASE_CONTEXT_EDITOR_TITLE = 'Edit phrase context';
export const PHRASE_CONTEXT_EDITOR_BUTTON = 'Apply new context';
export const PHRASE_CONTEXT_EDITOR_BUTTON_ADD = 'Apply context';
